export const ROUTE_PATHS = {
  ADMIN_COUPONS: '/admin/cupons',
  STORE_COUPONS: '/minha-loja/cupons',
  LOCAL_BUYER: '/$storeSlug/local',
  LOCAL_OWNER: '/minha-loja/local',
  HOME: '/',
  LOGIN: '/entrar',
  REGISTER: '/criar-conta',
  FORGOT_PASSWORD: '/recuperar-senha',
  SERVICE_UNAVAILABLE: '/servico-indisponivel',
  TERMS_OF_USE: '/termos-de-uso',
  PRIVACY_POLICY: '/politica-de-privacidade',
  INTELLECTUAL_PROPERTY: '/propriedade-intelectual',
  HELP: '/ajuda',
  HOW_TO_BUY: '/como-comprar',
  HOW_TO_SELL: '/como-vender',
  PROTECTED_PURCHASE: '/compra-protegida',
  RETURNS_AND_CANCELLATIONS: '/trocas-cancelamentos',
  FEES: '/taxas',
  SHIPPING_GUIDE: '/envios',
  PAYMENTS_GUIDE: '/pagamentos',
  PAYOUTS_GUIDE: '/recebimentos',
  CONTACT: '/contato',
  ABOUT: '/sobre',
  PROFILE: '/perfil',
  ADMIN_ACCOUNTS: '/administracao/contas',
  ADMIN_HOME: '/administracao',
  ADMIN_HEALTH: '/administracao/saude',
  ADMIN_INCIDENTS: '/administracao/incidentes',
  ADMIN_INCIDENT_DETAILS: '/administracao/incidentes/$codeOrId',
  ADMIN_PAYMENTS: '/administracao/pagamentos',
  ADMIN_STORES: '/administracao/lojas',
  ADMIN_ASSISTED_IMPORTS: '/administracao/importacoes-assistidas',
  ADMIN_INVENTORY: '/administracao/marketplace',
  ADMIN_ORDERS: '/administracao/pedidos',

  ADMIN_ORDER_DETAILS: '/administracao/pedidos/$orderId',
  ADMIN_ARTWORKS: '/administracao/catalogo/artes',
  ADMIN_CARDS: '/administracao/catalogo/cartas',
  ADMIN_RARITIES: '/administracao/catalogo/raridades',
  ADMIN_COLLECTION_DETAILS: '/administracao/catalogo/colecoes/$collectionId',
  ADMIN_COLLECTIONS: '/administracao/catalogo/colecoes',
  ADMIN_SHIPPING: '/administracao/fretes',
  ADMIN_FINANCE: '/administracao/financeiro',
  ADMIN_WITHDRAWALS: '/administracao/saques',
  MARKETPLACE: '/marketplace',
  CARDS: '/$gameCode/cards',
  CARD_DETAILS: '/$gameCode/cards/$cardSlug',
  STORE_FOLDER: '/$slug',
  STORE_PRODUCT_DETAILS: '/$slug/products/$offerId',
  ADMIN_PRODUCTS: '/admin/products',
  STORE_PRODUCTS: '/$slug/products',
  LEGACY_STORE_FOLDER: '/lojas/$slug',
  SELLER: '/minha-loja',
  INVENTORY_MULTIPLE_REGISTRATION: '/minha-pasta/cadastro-multiplo',
  INVENTORY_BULK_PRICE: '/minha-pasta/atualizacao-em-massa',
  STORE_PROMOTIONS: '/minha-loja/promocoes',
  STORE_SALES: '/minhas-vendas',
  STORE_FINANCE: '/minha-loja/financeiro',
  PURCHASES: '/minhas-compras',
  PURCHASE_DETAILS: '/minhas-compras/$orderId',
  SALE_DETAILS: '/minhas-vendas/$orderId',
  CART: '/carrinho',
  OPTIMIZED_PURCHASE: '/compra-otimizada',
  MY_DECKS: '/meus-decks',
  DECK_DETAILS: '/meus-decks/$deckId',
  DECK_IMPORT: '/meus-decks/$deckId/importar',
  PUBLIC_DECK: '/decks/$deckId',
} as const;
